import React from "react";
import {
  Alert,
  Box,
  Button,
  Chip,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Divider,
  IconButton,
  Stack,
  Tooltip,
  Typography,
} from "@mui/material";
import AddLinkOutlinedIcon from "@mui/icons-material/AddLinkOutlined";
import ContentCopyOutlinedIcon from "@mui/icons-material/ContentCopyOutlined";
import EditOutlinedIcon from "@mui/icons-material/EditOutlined";
import OpenInNewOutlinedIcon from "@mui/icons-material/OpenInNewOutlined";
import { isHttpsUrl } from "./revisionRapidaSaludUtils";

const RevisionLinksDialog = ({
  open,
  materials,
  loading,
  error,
  canManage,
  onClose,
  onCreate,
  onEdit,
  onCopy,
}) => (
  <Dialog open={open} onClose={loading ? undefined : onClose} fullWidth maxWidth="md">
    <DialogTitle>Enlaces y material de transcripción</DialogTitle>
    <DialogContent dividers>
      {error && <Alert severity="warning" sx={{ mb: 2 }}>{error}</Alert>}
      {!error && materials.length === 0 ? (
        <Alert severity="info">No hay enlaces o materiales cargados para esta convocatoria.</Alert>
      ) : (
        <Stack divider={<Divider flexItem />} spacing={0}>
          {materials.map((material) => {
            const safeUrl = isHttpsUrl(material.url);
            return (
              <Box key={material.id} sx={{ py: 1.5 }}>
                <Stack direction={{ xs: "column", sm: "row" }} justifyContent="space-between" gap={1.5}>
                  <Box minWidth={0}>
                    <Stack direction="row" gap={1} flexWrap="wrap" alignItems="center">
                      <Typography fontWeight={900}>{material.nombre}</Typography>
                      <Chip label={material.origen || "Enlace"} size="small" variant="outlined" />
                      <Chip
                        label={material.estado || "ACTIVO"}
                        size="small"
                        color={material.estado === "INACTIVO" ? "default" : "success"}
                      />
                    </Stack>
                    {material.descripcion && (
                      <Typography variant="body2" color="text.secondary" sx={{ mt: 0.5 }}>
                        {material.descripcion}
                      </Typography>
                    )}
                    {!safeUrl && (
                      <Typography variant="caption" color="error.main">URL no disponible por seguridad.</Typography>
                    )}
                  </Box>
                  <Stack direction="row" spacing={0.5} alignItems="center">
                    <Tooltip title="Copiar enlace">
                      <span>
                        <IconButton onClick={() => onCopy(material.url)} disabled={!safeUrl} aria-label={`Copiar ${material.nombre}`}>
                          <ContentCopyOutlinedIcon />
                        </IconButton>
                      </span>
                    </Tooltip>
                    <Tooltip title="Abrir enlace">
                      <span>
                        <IconButton
                          component={safeUrl ? "a" : "button"}
                          href={safeUrl ? material.url : undefined}
                          target={safeUrl ? "_blank" : undefined}
                          rel={safeUrl ? "noopener noreferrer" : undefined}
                          disabled={!safeUrl}
                          aria-label={`Abrir ${material.nombre}`}
                        >
                          <OpenInNewOutlinedIcon />
                        </IconButton>
                      </span>
                    </Tooltip>
                    {canManage && (
                      <Tooltip title="Editar enlace">
                        <IconButton onClick={() => onEdit(material)} aria-label={`Editar ${material.nombre}`}>
                          <EditOutlinedIcon />
                        </IconButton>
                      </Tooltip>
                    )}
                  </Stack>
                </Stack>
              </Box>
            );
          })}
        </Stack>
      )}
    </DialogContent>
    <DialogActions>
      {canManage && (
        <Button startIcon={<AddLinkOutlinedIcon />} onClick={onCreate} disabled={loading}>
          Agregar enlace
        </Button>
      )}
      <Button onClick={onClose} disabled={loading}>Cerrar</Button>
    </DialogActions>
  </Dialog>
);

export default RevisionLinksDialog;
